import React,{useEffect,useState} from 'react';
import Presenter from './DetailCategoryPresenter'
import { SEE_CATEGORY } from '../../Queries/seeCategory';
import { withRouter } from 'react-router-dom';
import { SEEUSER } from '../../Queries/seeUser';
import { SEE_TOPCOMMENT } from '../../Queries/seeTopComment';
import { useQuery, useMutation } from '@apollo/react-hooks'
import { DELETE_CATEGORY } from '../../Queries/Category/deleteCategory';
import { useHistory } from 'react-router-dom'
import { SEE_CATEGORIES } from '../../Queries/seeCategories';

export default withRouter(({ match: { params: { channelId, categoryId } } }) => {
    const history = useHistory();
    const { data: ctgData, loading: ctgLoading } = useQuery(SEE_CATEGORY, {
        variables: {
            id: categoryId
        }
    })
    const {data:cuData, loading:cuLoading} = useQuery(SEEUSER,{
        variables:{
            channelId
        }
    })
    const {data:tcData, loading: tcLoading, refetch}  = useQuery(SEE_TOPCOMMENT,{
        variables:{
            categoryId
        }
    })
    const [deleteCategoryMutation] = useMutation(DELETE_CATEGORY,{
        refetchQueries:[{
            query: SEE_CATEGORIES,
            variables:{
                userChannelId: channelId
            }
        }
    ],
        awaitRefetchQueries:true,
        onCompleted:()=>{
            history.goBack();
        }
    })
    const [ctgUpdateWindow, setCtgUpdateWindow ] = useState(false)
    const [ctgUpdateState, setCtgUpdateState] = useState(false)
     
    useEffect(()=>{
        refetch();
    },[refetch])

    
    const deleteClick= async() => {
        await deleteCategoryMutation({
            variables: {
                categoryId:ctgData.seeCategory.id
            }
        })

    }
    
    return(
        <Presenter 
            ctgData={ctgData}
            ctgLoading={ctgLoading}
            cuData={cuData}
            cuLoading={cuLoading}
            tcData={tcData}
            tcLoading={tcLoading}
            refetch={refetch}
            ctgUpdateWindow={ctgUpdateWindow}
            setCtgUpdateWindow={setCtgUpdateWindow}
            deleteClick={deleteClick}
            ctgUpdateState={ctgUpdateState}
            setCtgUpdateState={setCtgUpdateState}
        />
    )
})
